import _defineProperty from "@babel/runtime/helpers/defineProperty";
/* Copied from the ConsumerSite Pattern Library temporarily.
 *
 */

import React from "react";
import classnames from "classnames";
import styles from "./section-theme-provider.module.scss";
import { jsx as ___EmotionJSX } from "@emotion/core";
/**
 * Some components make use of third party packages,
 * that renders its content at the root of the body element,
 * as opposed to the main div where a React app is rendered
 * within. Which subsequently means that this third party
 * rendered content, will not have access to the design tokens
 * provided by the SectionThemeProvider.
 *
 * If the rendered content supports the use of custom classnames,
 * then this function will help provide the design tokens for the
 * given context.
 */
export var sectionThemeProviderClassnames = function sectionThemeProviderClassnames(_ref) {
  var className = _ref.className,
    theme = _ref.theme;
  return classnames(className, styles.sectionThemeProvider, _defineProperty({}, styles["theme-".concat(theme)], theme));
};
export var SectionThemeProvider = function SectionThemeProvider(_ref2) {
  var _ref2$theme = _ref2.theme,
    theme = _ref2$theme === void 0 ? "default" : _ref2$theme,
    children = _ref2.children,
    className = _ref2.className;
  return ___EmotionJSX("div", {
    "data-bpl": true,
    "data-constellation-section-theme": theme,
    className: classnames(className, styles.sectionThemeProvider, _defineProperty({}, styles["theme-".concat(theme)], theme))
  }, children);
};
export default SectionThemeProvider;